import { render, staticRenderFns } from "./IconArrowLeft.vue?vue&type=template&id=bcd55a00&scoped=true&"
import script from "./IconArrowLeft.vue?vue&type=script&lang=ts&"
export * from "./IconArrowLeft.vue?vue&type=script&lang=ts&"
import style0 from "./IconArrowLeft.vue?vue&type=style&index=0&id=bcd55a00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd55a00",
  null
  
)

export default component.exports